<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col-12 space">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-1">
              <router-link  to="/">{{$t("photography.breadcrumb_1")}}</router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="mx-1 breadcrumb-title">
              <router-link to="/propertiecreate">
                <!-- {{$t("photography.breadcrumb_2")}} -->
                {{$t("nav.realEstateServices")}}
              </router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-1 almarai-bold" aria-current="page">
              {{$t("photography.breadcrumb_3")}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row justify-content-center pt-3" v-if="step == 1">
      <div class="col-12 text-center">
        <div>
          <img src="/assets/images/icons/photography.png" class="photographyLogo" alt="">
        </div>
        <p class="pt-2 mb-0 orange-font">⁠{{$t('photography.title_1')}}</p>
        <p class="photographyTitle mb-0"> {{$t('photography.title_2')}} <br> {{$t('photography.title_3')}}</p>
      </div>
      <div class="col-10 col-md-4 pt-3 text-center mouse-hand">
        <div class="btn-green" @click="nextStep">{{$t('photography.button_nextStep')}}</div>
      </div>
    </div>
    <div class="row pt-4" v-if="step == 2">
      <div class="col">
        <div class="row justify-content-center">
          <div class="col-12 col-md-8">
            <div class="card border-0">
              <div class="card-body">
                <div class="row" v-if="hasError">
                  <div class="col">
                    <errorAlert :alertMessage="message" :errorNumber="errorNumber" />
                  </div>
                </div>
                <form action="">
                  <div class="row">
                    <div class="col">
                      <label for="" class="p-content">⁠ 
                        <span>{{$t('photography.fullName')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <input type="text" v-model="fullName" :placeholder="$t('photography.name_placeholder')"
                        class="form-control input-style" maxlength="50" @keypress="charsOnly"
                      >
                      
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.fullName.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="" class="p-content">
                        <span>{{$t('photography.phoneNumber')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <input type="text" v-model="mobile" :placeholder="$t('photography.mobile_placeholder')" 
                        class="form-control input-style" maxlength="10" @input="mobile = mobile.replace(/[^0-9]/g, '')"
                      >
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.mobile.$error">
                      {{ validateMessage }}
                    </div>
                  </div>

                  <div class="row pt-2">
                    <div class="col">
                      <label for="" class="p-content">
                        <span>{{$t('photography.region')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <Select2 
                        class="mouse-hand form-select input-style fonttext-14 style-form-select"
                        v-model="region"
                        :options="regionsObj"
                        @select="citiesList()"
                        ></Select2>
                      <!-- <select class="form-select input-style" @change="citiesList" v-model="region">
                        <option v-for="(region,index) in regions" :key="index" :value="region.id">{{region.name}}</option>
                      </select> -->
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.region.$error">
                      {{ validateMessage }}
                    </div>
                  </div>

                  <div class="row pt-2">
                    <div class="col">
                      <label for="" class="p-content">
                        <span>{{$t('photography.city')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <Select2
                        :placeholder="$t('home.ft_6')"
                        class="mouse-hand form-select input-style  fonttext-14 style-form-select"
                        modelValue="city"
                        v-model="city"
                        @click.prevent="checkRegions"
                        :options="cityObj"
                      ></Select2>
                      <!-- <select class="form-select input-style" v-model="city" @click.prevent="checkRegions">
                        <option v-for="(val,indx) in cities" :key="indx" :value="val.id" >{{val.name}}</option>
                      </select> -->
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.city.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                  <div class="row pt-2">
                    <div class="col">
                      <label class="p-content" for="">
                        <span>{{$t('photography.fullAddress')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <input type="text" class="form-control input-style" 
                        v-model="address" maxlength="50"
                      >
                      <!-- <textarea rows="4" class="form-control input-style" v-model="address"></textarea> -->
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.address.$error">
                      {{ validateMessage }}
                    </div>
                  </div>

                  <div class="row pt-2">
                    <div class="col">
                      <h6 class="p-content py-2">{{$t('photography.location')}}</h6>
                      <div ref="myMap" style="width: 100%; height: 320px;"></div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-6 pb-2">
                      <label class="p-content" for="">{{$t('addAd.title_70')}}</label>
                      <input type="number" class="form-control input-style" v-model="longitude">
                    </div>
                    <div class="col-12 col-md-6 pb-2">
                      <label class="p-content" for="">{{$t('addAd.title_71')}}</label>
                      <input type="number" class="form-control input-style" v-model="latitude">
                    </div>
                  </div>

                  <h6 class="almarai-bold py-2">
                    <span>{{$t('photography.package')}}</span>
                    <span class="stars">*</span>
                  </h6>
                  <div class="row">
                    <div v-for="(row,index) in rows" :key="index" :class="(packageId == row.id)? 'col-12 priceList input-style mb-2' : 'col-12 input-style mb-2'">
                      <label class="d-block  mouse-hand" :for="row.id">
                        <div class="row">
                          <div class="col content-center">
                            <input class="form-check-input radio" v-model="packageId" @change="selectedPackage" type="radio" :value="row.id" name="radioDefault" :id="row.id">
                            <span class="mx-2 almarai-bold">{{row.title}}</span>
                          </div>
                          <div class="col-auto">
                            <div class="text-end me-auto almarai-bold">{{row.price}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span></div>
                          </div>
                        </div>
                      </label>
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.packageId.$error">
                      {{ validateMessage }}
                    </div>
                  </div>

                  <div class="row pt-2">
                    <div class="col-12 position-R p-0">
                      <label class="p-content">{{$t('maintenances.title_9')}}</label>
                      <input type="text" id="discount" class="form-control input-style" v-model="discount">
                      <span class="discount_Photo" @click.prevent="checkDiscount">{{$t('maintenances.title_10')}}</span>
                    </div>
                  </div>
                  

                  <div class="row pt-4 justify-content-center">
                    <div class="col-10 col-md-4 text-center mouse-hand" @click="paymentFN">
                      <div class="btn-green">{{$t('photography.button_Payment')}}</div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--begin:form success-->
    <div class="row" v-if="step == 3">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <div><img src="/assets/images/icons/tick-circle-gold.png" class="circleGold" alt=""></div>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col text-center">
            <h4 class="almarai-bold">{{$t('photography.requestReceived')}}</h4>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col text-center">
            <span class="p-content">{{$t('photography.contactedSoon')}}</span>
          </div>
        </div>

        <div class="row py-4 justify-content-center">
          <div class="col-10 col-md-4">
            <router-link to="/">
              <button class="btn-green form-control">{{$t('formSuccess.title_4')}}</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!--end:form success-->

    <!-- begin:modal-payment -->
    <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="paymentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModal" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                {{$t('wallet.payment')}}
              </div>
              <div class="col-auto mouse-hand" id="closeModal" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="py-2 gray-color">{{$t('wallet.choosePayment_Method')}}</div>

            <div class="row py-3" v-if="totalCost">
              <label class="almarai-bold mb-2">{{$t('wallet.cost')}}</label>
              <div class="col-12">
                <div class="d-flex input-style">
                  <span class="gray-color almarai-bold">{{$t('wallet.cost')}}</span>
                  <div class="direction">
                    <span class="mx-2 gray-color almarai-bold">{{(hasCoupon)? newDiscount : totalCost}}</span>
                    <span>
                      <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <label class="almarai-bold pt-2">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'online')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/icons/bank.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_14')}}</span>
                    <span class="bankCard">{{$t('wallet.bankCard')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'wallet')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/wallet-3.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_16')}}</span>
                    <span class="bankCard">{{$t('wallet.appWallet')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <loader v-if="paymentLoading" class="text-center" />
              <div v-else class="col-10 col-md-8 text-center">
                <div @click.prevent="paymentSelected" class="form-control btn-green almarai-bold">{{$t('maintenanceDetails.title_5')}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:modal-payment -->


    <div class="modal bg-modal" id="selectRegion" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <img src="/assets/images/icons/Error.png" class="width-48" alt="">
              </div>
            </div>
            <div class="row justify-content-center pt-3">
              <div class="col text-center">
                <p class="mb-1 almarai-bold">{{$t('errorOccurred')}}</p>
                <h6 class="small-Font">{{$t('regionFirst')}}</h6>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-8 text-center mouse-hand text-white">
                <div class="btn-orange" @click="closePopup" >{{$t('continuation')}}</div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> -->
        </div>
      </div>
    </div>

    <!--begin:Charge your wallet -->
    <div class="modal bg-color-B" tabindex="-1" id="chargeWallet">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" @click="closePopupCharge" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('balanceInsufficient')}}</h6>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="small-Font">{{$t('chargeWallet')}}</div>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col">
                <router-link to="/wallet">
                  <div class="orange-btn fonttext-14">{{$t('btnChargeWallet')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:Charge your wallet -->

    <!--begin:popup wallet balance -->
    <button type="button" id="popup_Wallet" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#popup_WalletBalance">
      </button>
    <div class="modal bg-color-B" tabindex="-1" id="popup_WalletBalance">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" id="closeWalletBalance" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('walletPaymentConfirmation')}}</h6>
          <div class="modal-body">
            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('walletBalance')}}</div>
              <div class="col text-start">
                {{ USER_WALLET_BALANCE }}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="newDiscount === null">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                {{totalCost}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="newDiscount !== null">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                <span>{{totalCost}}</span>
              </div>
            </div>

            <div class="row" v-if="newDiscount !== null || discountPercentage">
              <div class="col-auto almarai-bold content-center">{{$t('priceDiscount')}}</div>
              <div class="col text-start">
                {{newDiscount}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('remainingBalance')}}</div>
              <div class="col text-start">
                {{ remainingBalance }}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div v-if="min_loader" class="text-center">
                <loader />
              </div>
              <div v-else class="col-10 col-md-7 text-center" @click.prevent="createPhotography">
                <div class="btn-green">{{$t('confirmButton')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:popup wallet balance -->

    <!-- Modal:begin couponPopup -->
    <button type="button" id="coupon" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#exampleModal">
    </button>
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content br-radius-24">
          <div class="modal-body text-center">
            <div><img src="/assets/images/icons/new-success.png" class="w-25" alt=""></div>
            <h6 v-if="value" class="pt-3"><span class="ms-1">{{$t('maintenances.title_9')}}</span> {{value.amount}} {{(value.discountType == "percentage" )? '%' : $t('maintenances.title_22') }}</h6>
            <p>{{$t('maintenances.title_20')}}</p>
            <div class="row justify-content-center">
              <div class="col-10 col-md-8">
                <div type="button" class="btn-green" data-bs-dismiss="modal">{{$t('maintenances.title_21')}}</div>
              </div>
            </div>
          </div>            
        </div>
      </div>
    </div>
    <!-- end:couponPopup -->
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { mapGetters } from 'vuex';
export default {
  name: 'photography',

  setup(){
    return { validate: useVuelidate() }
  },

  data(){
    return{
      hasError: false,
      message: '',
      errorNumber: null,
      isLoading: false,
      fullName: '',
      mobile: '',
      email: '',
      commercial_Activity: '',
      Project_Area: "",
      address: '',
      annualRent: '',
      remainingTerm: '',
      laborCount: null,
      longitude: null,
      latitude: null,
      step: 1,
      region: null,
      city: null,
      rows: [],
      packageId: null,
      paymentGate: '',
      regions: [],
      cities: [],
      validateMessage: this.$t('validateMessage'),
      showStyle: false,
      paymentLoading: false,
      totalCost: 0,
      remainingBalance: null,
      min_loader: false,
      userLang: 'ar',
      regionsObj: [],
      cityObj: [],
      discount: null,
      newDiscount: null,
      discountPercentage: null,
      value: {},
      hasCoupon: false,
    }
  },
  validations (){
    return {
      fullName: {required},
      mobile: {required},
      region: {required},
      city: {required},
      address: {required},
      packageId: {required},
    }
  },

  computed: {
    ...mapGetters(['USER_WALLET_BALANCE'])
  },
  methods:{
    createPhotography(){
      this.$http.post('/api/photos/create',{
        latitude: this.latitude,
        longitude: this.longitude,
        name: this.fullName,
        mobile: this.mobile,
        address: this.address,
        packageId: this.packageId,
        regionId: parseInt(this.region),
        cityId: parseInt(this.city),
        coupon: this.coupon,
        paymentGate: this.paymentGate,
      }).then(res => {
        // console.log(res);
        if(this.paymentGate == 'online' && res.data.paymentUrl ){
          window.location.href= res.data.paymentUrl;
        }else{
          if(this.paymentGate == 'wallet'){
            document.getElementById('closeWalletBalance').click();
          }
          this.step = 3;
        }
        window.scrollTo({top:0, behavior: 'smooth'});
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({top:0, behavior: 'smooth'});
      });
    },
    nextStep(){
      this.step = 2;
    },
    // get photo Packages List 
    packagesList(){
      this.$http.get('/api/photoPackages/list').then(res => {
        // console.log(res);
        this.rows = res.data.rows;
        this.regionList();
        this.getLocation();
        this.initialGoogleMap();
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
    //function get Location user
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.longitude = position.coords.longitude;
            this.latitude = position.coords.latitude;
          },
          (err) => {
            // this.error = `Error: ${err.message}`;
            // this.getData();
          }
        );
      } else {
        // this.error = "Geolocation is not supported by this browser.";
        // this.getData();
      }
    },
    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.latitude) ? parseFloat(this.latitude) :24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753, 
        },
        zoom: 8,
      });
      
      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { 
          lat: (this.latitude)? parseFloat(this.latitude) : 24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753 
        },
        map: this.map,
        draggable: true, // Allow dragging the marker
      });

      // Update lat/lng when marker is moved
      this.marker.addListener("dragend", () => {
        const pos = this.marker.getPosition();
        this.latitude = pos.lat();
        this.longitude = pos.lng();
        this.cityByLatFN();
      });

      // Click on the map to set a new marker position
      this.map.addListener("click", (event) => {
        this.latitude = event.latLng.lat();
        this.longitude = event.latLng.lng();
        this.marker.setPosition(event.latLng);
        this.cityByLatFN();
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script .src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },

    regionList(){
      this.hasError = false;
      this.$http.get('/api/regions/list').then(res => {
        // console.log(res);
        this.regions = res.data.regions;
        let regionOption = [];
        for (let R = 0; R < this.regions.length; R++) {
          regionOption.push({
            id: this.regions[R].id,
            text: this.regions[R].name,
          });
        }
        this.regionsObj = regionOption;
      }).catch (err => {
        [this.message , this.errorNumber] = this.$globalError(err ,true);
        this.hasError = true;
        window.scroll(0,0);
      })
    },

    citiesList(){
      this.hasError = false;
      this.$http.get(`/api/cities/list/?regionId=${this.region}`).then(res => {
        // console.log(res);
        this.cities = res.data.cities;
        let cityOptions = [];
          for (let i = 0; i < this.cities.length; i++) {
            cityOptions.push({ id: this.cities[i].id, text: this.cities[i].name });
          }
          this.cityObj = cityOptions;
      }).catch (err => {
        [this.message , this.errorNumber] = this.$globalError(err ,true);
        this.hasError = true;
        window.scroll(0,0);
      })
    },

    async paymentFN(){
      const valid = await this.validate.$validate();
      if(!valid){
        window.scrollTo({top:0, behavior: 'smooth'});
        return false;
      }
      if(!this.longitude || !this.latitude){
        this.message = this.$t('maintenances.locationRequired'); 
        this.errorNumber = 0;
        this.hasError = true;
        window.scroll(0,0);
        return false;
      }

      if(this.hasCoupon && this.value.discountType == 'percentage' && this.value.amount == 100){
        this.createPhotography();
        return false;
      }

      document.getElementById('selectPayment').click();
    },

    charsOnly(e) {
      // keep only Arabic letters, Latin letters, and spaces
      // requires modern JS regex support for Unicode property escapes
      const char = e.key;
      const allowed = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FFA-Za-z\s]$/;

      if (!allowed.test(char)) {
        e.preventDefault(); // block the input
      }
    },

    cityByLatFN(){
      this.$http.post('/api/cities/cityByLat',{
        longitude: this.longitude,
        latitude: this.latitude,
      }).then(res => {
        // console.log(res);
        if(res.data.region){
          this.region = res.data.region.id;
          this.citiesList();
        }
        if(res.data.city){
          this.city = res.data.city.id;
        }
        // if(res.data.neighborhood)
        //   this.propertyAdd.neighborhoodId = res.data.neighborhood.id;
      }).catch(err => {
        console.log(err);
      })
    },

    checkRegions(){
      if(!this.region){
        document.getElementById('selectRegion').style.display ='block';
      }
    },

    closePopup(){
      document.getElementById('selectRegion').style.display ='none';
    },

    selectedPackage(){
      this.rows.map((e)=> {
        if(e.id == this.packageId){
          this.totalCost = e.price;
        }
      })
    },

    async paymentSelected(){
      const valid = await this.validate.$validate();
      if(!valid){
        window.scrollTo({top:0, behavior: 'smooth'});
        return false;
      }
      this.paymentLoading = true;
      if(this.paymentGate == 'online'){
        this.createPhotography();
      }else {
        this.paymentLoading = false;
        document.getElementById('selectPayment').click();
        if(this.totalCost > this.USER_WALLET_BALANCE){
          document.getElementById('chargeWallet').style.display = 'block';
        }else{
          if(!this.hasCoupon)
            this.remainingBalance =  this.USER_WALLET_BALANCE - this.totalCost;
          document.getElementById('popup_Wallet').click();
        }
      }
    },

    closePopupCharge(){
      document.getElementById('chargeWallet').style.display = 'none';
    },

    checkDiscount(){
      this.hasError = false;
      this.$http.post("/api/coupons/available",{
        coupon: this.discount,
        modelName: 'photos',
      }).then(res => {
        // console.log(res);
        this.value = res.data.row;
        this.discountPercentage = res.data.row;
        document.getElementById('coupon').click();
        if(this.value.discountType == 'percentage'){
          this.newDiscount = this.totalCost - ((this.totalCost * this.value.amount) /100);
          this.remainingBalance = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.newDiscount);
        }else{
          this.newDiscount = this.totalCost - this.value.amount;
          this.remainingBalance = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.newDiscount);
        }
        this.hasCoupon = true;
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.hasCoupon = false;
      });
    },

  },
  created(){
    this.packagesList();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior: 'smooth'});
  }
}
</script>